import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";

/**
* @class Disclosure
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.disclosures[0];
* const device = new Disclosure(record);
* @property {NUMBER} _id - The id of the disclosure.
* @property {STRING} _title - The title of the disclosure.
* @property {BCMSDate} _date - The date of the disclosure.
*/

export default class Disclosure extends BCMSRecord {
    _id
    _title
    _date
    
    constructor (record){     
      super( record  ) 
    }
  }
Disclosure.define({
    "recordType":"disclosures",
    "recordIDProp":"id",
    "className" : "Disclosure",
    "recordProperties":[
        /** 
         * @name id
         * @instance
         * @property get {NUMBER} - gets the id of the disclosure
         * @property set {NUMBER} - sets the id of the disclosure
         * @memberof Disclosure 
         */
        BCMSRecordProperty.mapToNumber("id", "_id", "id"),

        /** 
         * @name title
         * @instance
         * @property get {STRING} - gets the title of the disclosure
         * @property set {STRING} - sets the title of the disclosure
         * @memberof Disclosure 
         */
        BCMSRecordProperty.mapToString("title", "_title", "title"),

        /** 
         * @name date
         * @instance
         * @property get {BCMSDate} - gets the date of the disclosure
         * @property set {BCMSDate} - sets the date of the disclosure
         * @memberof Disclosure 
         */
        BCMSRecordProperty.mapToDate("date", "_date", "date"),
      ]
})




